<template>
<div class="widget_slot loaded" data-widget-title="RealClearLife By InsideHook" data-widget-type="feed" style="min-height: 330px;">
    <div class="rec-widget-header">
        <div class="rec-title" style="color:#ffffff;">RealClearLife By InsideHook</div>
        <div class="rec-site" style="background:none;display:none;">
            <div class="name"></div>
            <span class="rec-site-tab"></span>
            <div class="rec-site-list"></div>
        </div>
    </div>
    <div class="rec-link-body" data-id="42">
        <ul class="">
            <li v-for="(item, index) in data.rc_life_second" :key="item.id" class="">
				<div class="content_wrapper">
					<div class="img_container">
						<a class="image item_left" :href="item.link" 
                        :onclick="`return ClickTracking.record_click(event, ${item.id}, '${encodeURIComponent(item.title)}', 'right-column-widget', 'RCLife_RCP_Homepage_RC', '1', '${(index + 1)}', 'RCLife+HP+Widgets');`">
						    <img :alt="item.title" class="content_img" :src="item.image" />
						</a>
					</div>
					<div class="title item_left">
						<a :href="item.link" :onclick="`return ClickTracking.record_click(event, ${item.id}, '${encodeURIComponent(item.title)}', 'right-column-widget', 'RCLife_RCP_Homepage_RC', '1', '${(index + 1)}', 'RCLife+HP+Widgets');`" v-html="item.title" >
						</a>
					</div>
			    </div>
			</li>
        </ul>
    </div>
</div>
</template>

<script>
export default {
    name: 'right-column-widget',
    data() {
        return {
            data: [],
        };
    },
    created(){
        this.initWidget();
    },
    methods: {
        
        initWidget(){

            $.ajax({
                crossDomain: true,
                url: 'https://www.realclearpolitics.com/include/rclife_second.jsonp',
                dataType: 'jsonp',
                jsonp: 'callback',
                jsonpCallback: 'rclife_second_callback',
                success : res => {
                    // console.log("rclife_second_callback", res);
                    this.$set(this, 'data', res);
                }
            });
        },

    },
}
</script>